import * as React from 'react';
import { Form } from 'react-final-form';
import { useTranslation } from 'react-i18next';
import { Button } from '@websky/core/src';
import { useTheme } from '@websky/core/src/theme';
import { useConfig } from '@websky/core/src/context';
import Field from '@websky/core/src/Forms/Field/Field';
import { removeTrailingSlash, useIsMobile } from '@websky/core/src/utils';
import { useRetrieveBookingValidation } from '@websky/core/src/RetrieveBooking/hooks';
import FieldInfoTooltip from '../FieldInfoTooltip/FieldInfoTooltip';
const Booking = () => {
    const engineURL = useConfig().SearchForm.engineURL;
    const { t } = useTranslation('Forms');
    const theme = useTheme('Forms').Booking;
    const isMobile = useIsMobile();
    const { ticketNumberValidation, validateByOrderNumber, requiredValidation, requiredValidationWrapper } = useRetrieveBookingValidation();
    const onOrderNumberValidation = (value) => {
        const ticketNumberError = ticketNumberValidation(value);
        const orderNumberError = validateByOrderNumber(value);
        if (!ticketNumberError || !orderNumberError) {
            return undefined;
        }
        return ticketNumberError || orderNumberError;
    };
    const onSubmit = (values) => {
        window.location.href = `${removeTrailingSlash(engineURL)}/#/find/${values['orderNumber']}/${values['lastName']}/Submit`;
    };
    return (React.createElement(Form, { onSubmit: onSubmit, initialValues: {
            orderNumber: '',
            lastName: ''
        } }, ({ handleSubmit }) => (React.createElement("div", { className: theme.container },
        React.createElement("form", { onSubmit: handleSubmit, className: theme.inner },
            React.createElement(Field, { name: "orderNumber", label: t('Order number'), validation: requiredValidationWrapper(onOrderNumberValidation), textFieldProps: {
                    InputProps: {
                        endAdornment: isMobile ? React.createElement(FieldInfoTooltip, { fieldName: t('Order number') }) : null
                    }
                } }),
            React.createElement(Field, { name: "lastName", label: t('Last name'), validation: requiredValidation }),
            React.createElement(Button, { type: "submit", variant: "flat", size: "large", className: theme.submit }, t('Find')))))));
};
export default Booking;
